import { combineReducers } from 'redux'
import dateReducer from './dateReducer';
import colorReducer from './colorReducer';

const rootReducer = combineReducers({
  date: dateReducer,
  color: colorReducer
});

export default rootReducer;